// Module
var code = "<div class=\"input-group\"> <input class=\"form-control\" ng-model=\"model[options.key]\" readonly=\"readonly\"> <div class=\"input-group-addon\" style=\"cursor:pointer\" ng-click=\"openMachineModal()\"> <i class=\"fa fa-search\"></i> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'machines/common/ui-formly/types/selectMachine/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;